var incidentTable;

function InitIncidentDataTable(dateFormat) {

    document.documentElement.style.setProperty('--toolbelt-loadingbar-color', 'transparent')

    //$(document).ready(function () {
        console.log("creating new table1");

        if (incidentTable != null) {
            try {
                incidentTable.destroy();
                incidentTable = null;
            } catch (e) {

            }
        }

        incidentTable = $('#incidentViewList').DataTable({
            "order": [[1, "desc"]],
            pageLength: 25,
            autoWidth: false,
            "columnDefs": [
                { "width": "72px", "targets": 0 }, //Incident #
                { "width": "196px", "targets": 1 }, //Happened
                { "width": "100px", "targets": 2 }, //Unit
                { "width": "100px", "targets": 3 }, //Location
                { "width": "128px", "targets": 4 }, //Title
                { "width": "384px", "targets": 5 }, //Description
                { "width": "64px", "targets": 6 }, //Follow up needed
                { "width": "128px", "targets": 7 } //Category list
            ],
            "language": {
                "emptyTable": "There are currently no incidents. Create a new incident with the button in the top right",
                "info": "Showing _START_ to _END_ of _TOTAL_ incidents",
                "infoEmpty": "Showing 0 to 0 of 0 incidents",
                "infoFiltered": "(filtered from _MAX_ total incidents)",
                "lengthMenu": "Show _MENU_ incidents"
            },
            columns: [
                {
                    data: 'incidentNumber',

                },
                {
                    data: 'created',
                    render: function (data, type) {
                        if (type === 'display') {
                            if (dateFormat == 0) {
                                return timestampToJexcelDate(data);}
                            else {
                                return timestampToUsDate(data);
                            }
                            
                           
                        }

                        return data;
                    }
                },
                {
                    data: 'unit'
                },
                {
                    data: 'location'
                },
                {
                    data: "title"
                },
                {
                    data: "text"
                },
                {
                    data: 'followUpNeeded',
                    render: function (data, type) {
                        if (type === 'display') {
                            if (data == true) {
                                return "yes";
                            }
                            else {
                                return "no";
                            }
                        }

                        return data;
                    }
                    //render: function (data, type, row, meta) {
                    //    return type === 'display' ?
                    //        '<progress value="' + data + '" max="9999"></progress>' :
                    //        data;
                    //}
                },
                {
                    data: 'typeCategoryList',
                    render: function (data, type) {
                        if (type === 'display') {
                            try {
                                var categories = data.split(";");
                                var displayText = categories.filter(function (val) { return val; }).join(', ');
                                return displayText;

                            } catch {}
                           
                        }

                        return data;
                    }
                    //render: function (data, type, row, meta) {
                    //    return type === 'display' ?
                    //        '<progress value="' + data + '" max="9999"></progress>' :
                    //        data;
                    //}
                },
                //{
                //    data: 'priority',
                //    render: function (data, type) {
                //        if (type === 'display') {

                //            if (data == 3) {
                //                return '<strong><span style="color:red;">Critical</span></strong>';
                //            } else if (data == 2){
                //                return '<span>High</span>';
                //            }
                //            else if (data == 1) {
                //                return '<span>Medium</span>';
                //            }
                //            else if (data == 0) {
                //                return '<span>Low</span>';
                //            }

                //            return "";
                //        }

                //        return data;
                //    }
                //}
            ]
        });

        $('#incidentViewList tbody').on('click', 'tr', function () {
            var data = incidentTable.row(this).data();
            console.log(data);

            var incidentNumberParsed = -1;

            try {
                incidentNumberParsed = parseInt(data.incidentNumber);
            } catch (e) {

            }

            if (incidentNumberParsed > 0) {
                console.log("incidentNumberParsed:" + incidentNumberParsed);
                DotNet.invokeMethodAsync('VisitForm.Client.UI.ModulesA', 'OnIncidentClickedFromGrid', incidentNumberParsed);
            }

       
            
        });

        $("#incidentViewList tr").css('cursor', 'pointer');

   // });
}

function FilterIncidentDataTableOnAssignedTo(assignedToName) {
    if (incidentTable != null) {
        incidentTable.columns(6).search(assignedToName).draw();
    }
    
}

function RemoveAssignedToFilterIncidentDataTable(arg) {
    if (incidentTable != null) {
        incidentTable.columns(6).search('').draw();
    }
    
}

function PopulateToIncidentDataTable(rows) {

    console.log("rows");
    console.log(rows);

    var incidents = [];

    rows.forEach(row => incidents.push({
        incidentNumber: row.incidentId,
        unit: row.incidentUnit,
        location: row.incidentLocation,
        created: new Date(row.incidentTimestamp),
        duedate: row.incidentDueDate == null ? null : new Date(row.incidentDueDate),
        priority: row.incidentPriority,
        typeCategoryList: row.incidentTypeCategoryList,
        title: row.incidentTitle,
        followUpNeeded: row.incidentFollowUpNeeded,
        assignedTo: row.incidentAssignedTo,
        unit: row.incidentReceiverUnit,
        text: row.incidentText
    }));

  //  incidents = incidents.reverse();

    console.log("incidents");
    console.log(incidents);

    try {
        incidentTable.rows().remove()
    } catch (e) {
        console.log(e);
    }

    console.log("updating");

    try {
        incidentTable.rows.add(incidents);
        incidentTable.draw();

    } catch (e) {
        console.log(e);
    }

    

    console.log("updated");
}

function ReloadIncidentDataTable(row) {

    console.log("reloading table..");
    if (incidentTable != null) {
        console.log("destroying table..");
        incidentTable.destroy();
        setTimeout(function () {
            console.log("buuilding table..");
            InitIncidentDataTable();
        }, 2000);
    }

    //  incidentTable.row.add([row.incidentEventIncidentId, row.incidentEventState, 'Edinburgh']);

    //$(document).ready(function () {
    //    //$('#example').DataTable().destroy();
    //    console.log("creating new table2");
    //   // $('#example').DataTable();

    //    //incidentTable.clear();
    //    var data = incidentTable.data();
    //    incidentTable.draw();
    //});
}


function ForceStateSelectIndex(valueToSelect) {
    var element = document.getElementById("incidentDetailViewStateSelect");
    element.value = valueToSelect;
}

function ForcePrioritySelectIndex(valueToSelect) {
    var element = document.getElementById("incidentDetailViewPrioritySelect");
    element.value = valueToSelect;
}


function InitIncidentViewGuardsTypeahead(guards) {

    var guardsRaw = [];

    var count = guards.length;
    for (var i = 0; i < count; i++) {
        var name = guards[i].guardName;
        if (name !== "") {
            guardsRaw.push(name);
        }
    }

    console.log(guardsRaw);

    $(document).ready(function () {
        buildTypeahead('#guardIncidentViewSelect .typeahead', "guards", guardsRaw);
    });

    

    return true;
}

function InitIncidentViewResidentsTypeahead(people) {

    var peopleRaw = [];

    var count = people.length;
    for (var i = 0; i < count; i++) {
        var name = people[i].receiverName;
        var unit = people[i].receiverUnit;
        var phone = people[i].receiverPhonenumber;
        var email = people[i].receiverEmail;
        if (name !== "") {
            peopleRaw.push(unit);
        }
    }

    buildTypeahead('#residentIncidentViewSelect .typeahead', "people", peopleRaw);

    return true;
}


//////

var incidentDueDateRangePickerElementId = 'incidentDueDateRangePickerViewer';
var incidentDueDateRangePickerStartSelected = '';

var lastIncidentViewDateRangeValueShown = null;

function buildIncidentDueDateRangePickers(dateFormat, startDate) {

    $(document).ready(function () {

        $('#' + incidentDueDateRangePickerElementId).on('apply.daterangepicker', function (ev, picker) {
            console.log("clicked apply setting date");
            // alert("New date range selected: '" + picker.startDate.format('YYYY-MM-DD') + "' to '" + picker.endDate.format('YYYY-MM-DD') + "'");

            //console.log(start);
            //console.log(start.date());
            //console.log(start.month());
            //console.log(start.year());
           // incidentDueDateRangePickerStartSelected = start.toISOString();
            var start = picker.startDate;
            incidentDueDateRangePickerStartSelected = start.toISOString();

            console.log(dateFormat);
            //dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY'
            var resultDate = '';

            if (dateFormat == 0) {
                resultDate = n2(start.date()) + "/" + n2(start.month() + 1) + "/" + start.year();
            } else {
                resultDate = n2(start.month() + 1) + "/" + n2(start.date()) + "/" + start.year();
            }

            document.getElementById('incidentDueDateRangePickerViewer').value = resultDate;

            console.log(incidentDueDateRangePickerStartSelected);

        });

        $('#' + incidentDueDateRangePickerElementId).on('cancel.daterangepicker', function (ev, picker) {
            console.log("clicked cancel setting date");
            // alert("New date range selected: '" + picker.startDate.format('YYYY-MM-DD') + "' to '" + picker.endDate.format('YYYY-MM-DD') + "'");
            document.getElementById('incidentDueDateRangePickerViewer').value = '';
       

        });

       

        $('#' + incidentDueDateRangePickerElementId).on('show.daterangepicker', function (ev, picker) {

            console.log(picker.container[0]);

            $(picker.container[0]).find('.drp-buttons .cancelBtn').text("Reset");
            //console.log(elx);

            //$($(picker.container[0]).find('.drp-buttons .cancelBtn')).each(function (i, obj) {
            //    console.log(obj);
             
            //});

            var currentValue = document.getElementById('incidentDueDateRangePickerViewer').value;
            lastIncidentViewDateRangeValueShown = currentValue;
        });

        $('#' + incidentDueDateRangePickerElementId).on('hide.daterangepicker', function (ev, picker) {
            //$('#book_date').val('');
            //console.log("clicked outside setting date to empty");
            //document.getElementById('incidentDueDateRangePickerViewer').value = '';

            if (lastIncidentViewDateRangeValueShown != null) {
                document.getElementById('incidentDueDateRangePickerViewer').value = lastIncidentViewDateRangeValueShown;
                lastIncidentViewDateRangeValueShown = null;
            }

        });


    });

    $(document).ready(function () {
        $('#' + incidentDueDateRangePickerElementId).daterangepicker({
            singleDatePicker: true,
            timePicker: false,
            startDate: moment().add(0, 'day')
        }, function (start, end, label) {

            //console.log(start);
            //console.log(start.date());
            //console.log(start.month());
            //console.log(start.year());
            //incidentDueDateRangePickerStartSelected = start.toISOString();

            //console.log(dateFormat);
            ////dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY'
            //var resultDate = '';

            //if (dateFormat == 0) {
            //    resultDate = n2(start.date()) + "/" + n2(start.month() + 1) + "/" + start.year();
            //} else {
            //    resultDate = n2(start.month() + 1) + "/" + n2(start.date()) + "/" + start.year();
            //}

            //document.getElementById('incidentDueDateRangePickerViewer').value = resultDate;
         
            //console.log(incidentDueDateRangePickerStartSelected);

        });

    });
}

function setIncidentDueDateRangerPickerDate(date) {
    try {
        var dateToSet = new Date(date);
        $('#' + incidentDueDateRangePickerElementId).data('daterangepicker').setStartDate(dateToSet);
        $('#' + incidentDueDateRangePickerElementId).data('daterangepicker').setEndDate(dateToSet);
    } catch (e) {
        console.log(e);
    }
}


function getIncidentDueDateRangePickerStartSelected() {
    return incidentDueDateRangePickerStartSelected;
}

//////

function maintenanceIncidentDone(maintenanceIncidentId, el) {

    //var buttonElementId = "maintenanceIncidentDoneButton-" + maintenanceIncidentId;

    //console.log("buttonElementId: " + buttonElementId);

    var buttonElement = el;

    console.log("buttonElement to set animation");
    console.log(buttonElement);


    $(buttonElement).addClass("slide_right_done");
    //buttonElement.classList.add('slide_right_done');

   // buttonElement.innerHTML = "DONE";



    DotNet.invokeMethodAsync('VisitForm.Client.UI.ModulesA', 'OnMaintenanceIncidentClickedDoneFromGrid', maintenanceIncidentId);

    setTimeout(function () {

       
       

        console.log("click event btn");
        console.log(buttonElement);

      //  $(".button_slide").removeClass("slide_right_done");


    }, 1000);


   
}

function removeAllDoneButtonAnimations(arg) {
    $(".button_slide").removeClass("slide_right_done");
}

//function (el, overdue, ooingng) {

//    setTimeout(function () {
//        tippy('#' + el, {
//            arrow: false,
//            content: '<span>' + 'A VisitForm Ultimate license is required to send texts.' + '</span>',
//            allowHTML: true
//        });
//    }, 3500);

//}

function createMaintenanceIncidentStatusTooltip(el, overdue, ongoing, endsSoon) {

    var text = "Done and on schedule";

    if (overdue) {
        text = "Overdue and to be done as soon as possible";
    }
    else if (ongoing) {
        if (endsSoon) {
            text = "Due in less than one hour";
        }
        else {
            text = "Planned time passed and should be done before due date";
        }
        
    }

    setTimeout(function () {
        tippy('#' + el, {
            content: '<span>' + text + '</span>',
            allowHTML: true
        });
    }, 1500);

}


function createMaintenanceIncidentTooltip(el, text) {


    setTimeout(function () {
        tippy(el, {
            content: '<span>' + text + '</span>',
            allowHTML: true
        });
    }, 1500);

}

function showMaintenanceIncidentModalInfo(maintenanceIncident) {

    console.log("maintenanceIncident");
    console.log(maintenanceIncident);

    document.getElementById('showMaintenanceIncidentModalTitle').innerHTML = maintenanceIncident.maintenanceIncidentTitle;

    //

    if (maintenanceIncident.maintenanceIncidentIntervalDescription) {
        document.getElementById('showMaintenanceIncidentModalIntervalDescription').innerHTML = maintenanceIncident.maintenanceIncidentIntervalDescription;
        $('#showMaintenanceIncidentModalIntervalDescriptionLabel').show();
    }
    else {
        document.getElementById('showMaintenanceIncidentModalIntervalDescription').innerHTML = "";
        $('#showMaintenanceIncidentModalIntervalDescriptionLabel').hide();
    }

    //

    if (maintenanceIncident.maintenanceIncidentDescriptionHelpInfo) {

        var helpInfoMessageText = maintenanceIncident.maintenanceIncidentDescriptionHelpInfo;

        try {
            helpInfoMessageText = helpInfoMessageText.replace(/\n/g, '<br>');
        }
        catch {

        }


        document.getElementById('showMaintenanceIncidentModalDescriptionHelpInfo').innerHTML = helpInfoMessageText;
        $('#showMaintenanceIncidentModalDescriptionHelpInfoLabel').show();
    }
    else {
        document.getElementById('showMaintenanceIncidentModalDescriptionHelpInfo').innerHTML = "";
        $('#showMaintenanceIncidentModalDescriptionHelpInfoLabel').hide();
    }


    //

    if (maintenanceIncident.maintenanceIncidentDescription) {
        document.getElementById('showMaintenanceIncidentModalDescription').innerHTML = maintenanceIncident.maintenanceIncidentDescription;
        $('#showMaintenanceIncidentModalDescriptionLabel').show();
    }
    else {
        document.getElementById('showMaintenanceIncidentModalDescription').innerHTML = "";
        $('#showMaintenanceIncidentModalDescriptionLabel').hide();
    }

    //
   
    $('#showMaintenanceIncidentInfoModal').modal();

}




function uploadIncidentImage(baseUrl, arg, inputid, frm, screenlink, blobidentifier) {

    let path = 'api/Image/incidentimageupload/fromlink/';

    if (frm !== "fromlink") {
        path = 'api/Image/incidentimageupload/';
    }

    // Safe URL join
    const url = new URL(
        path + encodeURIComponent(screenlink) + "/" + encodeURIComponent(blobidentifier),
        baseUrl.endsWith('/') ? baseUrl : baseUrl + '/'
    ).toString();

    var file_data = $('#' + inputid).prop('files')[0];
    var form_data = new FormData();
    form_data.append('file', file_data);

    $.ajax({
        url: url,
        dataType: 'text',
        cache: false,
        contentType: false,
        processData: false,
        data: form_data,
        type: 'post',
        beforeSend: function (xhr) {
            xhr.setRequestHeader("Authorization", 'Bearer ' + arg);
        },
        success: function () {
            DotNet.invokeMethodAsync(
                'VisitForm.Client.UI.ModulesA',
                'OnIncidentImageUploadDoneFromAjax',
                blobidentifier,
                201
            );
        },
        error: function () {
            DotNet.invokeMethodAsync(
                'VisitForm.Client.UI.ModulesA',
                'OnIncidentImageUploadDoneFromAjax',
                blobidentifier,
                500
            );
        }
    });
}


function StartIncidentImageUpload() {

    $("#incidentReadFileInput").click();
}

function FileChosenIncident(e) {

    try {
        var fileName = $('#inputGroupFile01').prop('files')[0].name;
       // document.getElementById('chosenFileLabel').innerHTML = fileName;
    } catch (e) {

    }


}

function incidentDisplayImage(checkinId, blobIdentifier) {
    DotNet.invokeMethodAsync('VisitForm.Client.UI.ModulesA', 'OnDashboardShowPhotoOpenedByUser', checkinId, blobIdentifier);
}


function openIncidentDisplayImageModal(arg) {
    $('#incidentShowPhotoModal').modal().appendTo("body");
}

